import { render, staticRenderFns } from "./picTextComponent.vue?vue&type=template&id=129167d4&scoped=true&"
import script from "./picTextComponent.vue?vue&type=script&lang=js&"
export * from "./picTextComponent.vue?vue&type=script&lang=js&"
import style0 from "./picTextComponent.vue?vue&type=style&index=0&id=129167d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129167d4",
  null
  
)

export default component.exports